import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Box, Button, Typography } from '@mui/material';

import { ArrowIcon } from '~/components/icons';
import { Page } from '~/components/Page';
import { HomePageUrl } from '~/pages/urls';

export const RouteNotFound: React.FC = () => (
  <Page>
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        my: 'auto',
      }}
    >
      <Typography align="center" color="textPrimary" variant="h1">
        404: The page you are looking for could not be found.
      </Typography>
      <Typography align="center" color="textPrimary" variant="subtitle2">
        You either tried an url that no longer exists or you came here by
        mistake. Try using the navigation
      </Typography>
      <Button
        variant="contained"
        sx={{ mt: 3 }}
        to={HomePageUrl}
        component={RouterLink}
        startIcon={(
          <ArrowIcon sx={({ palette: { primary } }) => ({
            width: 14,
            height: 16,
            transform: 'rotateX(180deg)',
            path: { fill: primary.contrastText },
          })} />
        )}
      >
        Go back to homepage
      </Button>
    </Box>
  </Page>
);
